export default class PersonalReportModel {
    constructor() {
        this._performance = "";
        /** @type {PersonalReportTip[]} */
        this._tips = [];
    }

    get performance() {
        return this._performance;
    }

    set performance(value) {
        this._performance = value;
    }

    get tips() {
        return this._tips;
    }

    addTip(tip) {
        this._tips.push(tip);
    }

    addTips(tips) {
        this._tips.push(...tips);
    }

    isPopulated() {
        return this._performance !== "" && this._tips.length > 0;
    }

    toObject() {
        return {
            performance: this._performance,
            tips: this._tips.map(tip => tip.toObject())
        };
    }

    load(obj) {
        this._performance = obj?.performance;
        this._tips = (obj?.tips || []).map(tipObj => {
            const tip = new PersonalReportTip(tipObj);
            return tip;
        });
    }
}

export class PersonalReportTip {
    /**
     * @constructor
     * @param {Object} params
     * @param {string} params.title
     * @param {string} params.content
     */
    constructor({ title, content }) {
        this._title = title;
        this._content = content;
    }

    get title() {
        return this._title;
    }

    get content() {
        return this._content;
    }

    toObject() {
        return {
            title: this._title,
            content: this._content
        };
    }

    fromObject(obj) {
        this._title = obj.title;
        this._content = obj.content;
    }
}